import { LoginConfig } from '@ixigo-packages/login';
import { getCookieHelpers } from './cookie';
import { getCookie, insideIFrame } from './common';
import { LocalStorage } from '../enums/common';

export const loginConstants = {
    recaptchaToken: '6LcyoLcUAAAAAIawkLXQYgj61-aAhBT8HphqYI6Q',
    googleClientId: '609822318055-7gifp26me07tnaphkgu3ilf51hjusat6.apps.googleusercontent.com',
    resendTimer: 60,
};

export const isLoggedIn = () => {
    if (typeof document !== 'undefined') {
        const result = document.cookie.match('(^|;)\\s*at\\s*=\\s*([^;]+)');
        if (insideIFrame()) {
            return result ? !!result.pop() : !!getCookie('at');
        }
        return result ? !!result.pop() : false;
    }
    return false;
};

export const getLoginConfig = () => {
    const cookieHelpers = getCookieHelpers();
    const { clientId, apiKey } = cookieHelpers.getAllCookies();
    const { recaptchaToken, resendTimer, googleClientId } = loginConstants;
    const config: LoginConfig = {
        apiKey: apiKey as string,
        clientId: clientId as string,
        recaptchaToken,
        cookie: cookieHelpers,
        localStorage: typeof window !== 'undefined' ? window.localStorage : undefined,
        resendTimer,
        googleClientId,
        autoGoogleLogin: true,
        product: 'FLIGHT',
        otplessEnabled: true,
    };
    return config;
};
export const logout = () => {
    const { clearCookie } = getCookieHelpers();
    clearCookie('at');
    clearCookie('lt');
    localStorage.removeItem(LocalStorage.CACHED_USER_INFO_KEY);
    window.location.reload();
};
